module.exports = __webpack_public_path__ + "diamo1.jpg?cf138aaa9e63311a05684d4c5346c6b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/diamo1.jpg
// module id = 227
// module chunks = 0